'use client'

import { motion } from 'framer-motion'
import { useRef } from 'react'
import { CapabilityList } from './capability-list'
import { MagneticLink } from './magnetic-button'
import { RevealText } from './reveal-text'

export function ServicesSection() {
  const sectionRef = useRef<HTMLElement>(null)

  return (
    <section ref={sectionRef} id="services" className="px-6 py-32 md:py-48 lg:px-12">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 grid gap-8 md:mb-24 md:grid-cols-12">
          <div className="md:col-span-8">
            <RevealText className="mb-4">
              <span className="text-xs tracking-[0.3em] uppercase text-accent">Capabilities</span>
            </RevealText>
            <RevealText delay={0.1}>
              <h2 className="font-serif text-4xl tracking-tight md:text-6xl lg:text-7xl">
                Everything you need
                <br />
                <span className="italic text-muted-foreground">under one roof.</span>
              </h2>
            </RevealText>
          </div>
          <div className="md:col-span-4 md:flex md:items-end">
            <RevealText delay={0.2}>
              <p className="font-serif text-lg italic text-muted-foreground">
                From first sketch to production deploy - we design, build, and ship digital products
                for founder-led teams.
              </p>
            </RevealText>
          </div>
        </div>

        <CapabilityList />

        <motion.div
          className="mt-16 flex flex-col items-start justify-between gap-6 border-t border-border pt-12 sm:flex-row sm:items-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          <p className="font-serif italic text-muted-foreground">
            See packages and pricing on our services page.
          </p>
          <MagneticLink href="/services" variant="outline">
            View packages
          </MagneticLink>
        </motion.div>
      </div>
    </section>
  )
}
